module.exports = __webpack_public_path__ + "static/social-lebc-28f53871ffe62d7637fb91dd79ec8dca.mp4";